var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn global-setting-page-container" },
    [
      _c("div", { staticClass: "h1-text" }, [_vm._v("SETTINGS")]),
      _vm._v(" "),
      _c("SubHeader"),
      _vm._v(" "),
      _c("TableGloBalSettings", { attrs: { loading: _vm.isLoading } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "staff-management-container" },
        [
          _c("StaffManagement", {
            attrs: { staffSettings: _vm.settings.staffConfiguration }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "h2-text margin-top-24px" }, [
        _vm._v("\n    Global Email Template\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.configEmail.emailTags.length
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("div", { staticClass: "h3-text margin-top-24px" }, [
                  _vm._v("Reset Password Email Template")
                ]),
                _vm._v(" "),
                _c("vue-ckeditor", {
                  attrs: { config: _vm.configEmail },
                  model: {
                    value: _vm.settings.resetPasswordEmailTemplate.body,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.settings.resetPasswordEmailTemplate,
                        "body",
                        $$v
                      )
                    },
                    expression: "settings.resetPasswordEmailTemplate.body"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.configEmail.emailTags.length
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("div", { staticClass: "h3-text margin-top-24px" }, [
                  _vm._v("Temporary Password Email Template")
                ]),
                _vm._v(" "),
                _c("vue-ckeditor", {
                  attrs: { config: _vm.configEmail },
                  model: {
                    value: _vm.settings.temporaryPasswordEmailTemplate.body,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.settings.temporaryPasswordEmailTemplate,
                        "body",
                        $$v
                      )
                    },
                    expression: "settings.temporaryPasswordEmailTemplate.body"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 margin-top-24px" }, [
          _c(
            "button",
            {
              staticClass: "ap-btn primary",
              on: {
                click: function($event) {
                  _vm.saveData()
                }
              }
            },
            [_vm._v("Save")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08433b7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08433b7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/globalSettings/GlobalSettings.vue
// module id = 2078
// module chunks = 1